import React from "react";
import { useChatContext } from "../../../contexts/ChatContext";
import { useSidebarContext } from "../../../contexts/SidebarContext";
import styles from "./ChatList.module.css";

function sortChatsList(chatsObj: any) {
  // Trả về mảng key, sắp xếp theo thời gian tin nhắn cuối cùng giảm dần
  return Object.keys(chatsObj).sort((a, b) => {
    const lastA = chatsObj[a].messages.length > 0 ? chatsObj[a].messages[chatsObj[a].messages.length - 1].messagetime : 0;
    const lastB = chatsObj[b].messages.length > 0 ? chatsObj[b].messages[chatsObj[b].messages.length - 1].messagetime : 0;
    return lastB - lastA;
  });
}

const ChatList: React.FC = () => {
  const { chats } = useChatContext();
  const { setChatBeingViewedId, setContentType } = useSidebarContext();
  const chatKeys = sortChatsList(chats);

  return (
    <>
      <div className={styles["chat-list-header"] + " text"}>
        {/* <button className="left-btn new-chat-btn btn text" title="Tạo trò chuyện mới">...</button> */}
        <div className="text">SĐT của bạn: +104441000003</div>
        {/* <button className="right-btn refresh-chat-btn btn text" title="Làm mới danh sách">...</button> */}
      </div>
      <div className={styles["chat-list"]} id="chatList">
        {chatKeys.map((key) => {
          const chat = chats[key];
          const lastMessage = chat.messages[chat.messages.length - 1];
          const lastMessageTime = lastMessage ? new Date(lastMessage.messagetime) : null;
          return (
            <div
              className={styles["chat-item"]}
              key={key}
              onClick={() => {
                setChatBeingViewedId(key)
                setContentType("chatMessage");
              }}
            >
              <div className={styles["chat-name"] + " text-large position-relative"}>
                {chat.contactName == "#" ? key : chat.contactName}
                <span
                  id="message-notification-dot"
                  className={
                    (!chat.read ? "" : "d-none") +
                    " position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger p-1"
                  }
                >
                  {" "}
                </span>
              </div>
              <p className={styles["chat-preview"] + " text"}>{lastMessage?.message ?? ""}</p>
              <p className={styles["chat-time"] + " text-small"}>{lastMessageTime ? lastMessageTime.toLocaleString() : ""}</p>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ChatList;
